import { AnonymousStudentServiceReady } from '@studyportals/anonymous-student-interfaces';
import { SessionServiceReadyEvent } from '@studyportals/student-interfaces';
import { CopilotServiceReadyEvent } from '@studyportals/copilot-service-interfaces';
import globals from '../../utils/globals';
import { store } from '../store';
import {
	IEventAggregationService,
	ISubscriber,
} from '@studyportals/event-aggregation-service-interface';

export class DependencyCheckerPlugin
implements
		ISubscriber<AnonymousStudentServiceReady | SessionServiceReadyEvent | CopilotServiceReadyEvent>
{
	private anonymousStudentIsReady = false;
	private sessionServiceReady = false;
	private copilotServiceIsReady = false;

	private get eventAggregationService(): IEventAggregationService | null {
		if (typeof window['EventAggregationService'] === 'undefined') {
			return null;
		}
		return window['EventAggregationService'];
	}

	public initialize(): void {
		if (!this.eventAggregationService) {
			return;
		}

		globals.eventAggregationService = this.eventAggregationService;

		this.eventAggregationService.subscribeTo(
			AnonymousStudentServiceReady.EventType,
			this,
			true,
		);
		this.eventAggregationService.subscribeTo(
			SessionServiceReadyEvent.EventType,
			this,
			true,
		);

		this.eventAggregationService.subscribeTo(
			CopilotServiceReadyEvent.EventType,
			this,
			true,
		);
	}

	public async notify(
		event: AnonymousStudentServiceReady | SessionServiceReadyEvent | CopilotServiceReadyEvent,
	): Promise<void> {
		if (event.eventType === AnonymousStudentServiceReady.EventType) {
			this.handleAnonymousStudentReady(event as AnonymousStudentServiceReady);
		}

		if (event.eventType === SessionServiceReadyEvent.EventType) {
			this.handleSessionServiceReady(event as SessionServiceReadyEvent);
		}

		if(event.eventType === CopilotServiceReadyEvent.EventType) {
			this.handleCopilotServiceReady(event as CopilotServiceReadyEvent);
		}

		if (this.anonymousStudentIsReady && this.sessionServiceReady && this.copilotServiceIsReady) {
			await store.actions.setAreDependenciesLoaded(true);
		}
	}

	private handleCopilotServiceReady(event: CopilotServiceReadyEvent): void {
		globals.copilotServiceApplication = event.copilotServiceApplication;
		this.copilotServiceIsReady = true;
	}

	private handleAnonymousStudentReady(
		event: AnonymousStudentServiceReady,
	): void {
		globals.anonymousStudent = event.anonymousStudentService;
		this.anonymousStudentIsReady = true;
	}

	private handleSessionServiceReady(event: SessionServiceReadyEvent): void {
		globals.sessionService = event.sessionService;
		this.sessionServiceReady = true;
	}
}
